<template>
  <div class="page-licenses">
    <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2 mb-3">My Music Licenses</h1>
    <div class="row">
      <div class="col">
        <b-table class="mt-3" striped hover :items="items" :fields="fields">
          <template v-slot:cell(ArvcId)="data">
            <router-link :to="`/license/${data.item.SfId}`">{{ data.value }}</router-link>
          </template>
          <template v-slot:cell(Account)="data">
            <v-clamp autoresize :max-lines="1">{{ data.value }}</v-clamp>
          </template>
          <template v-slot:cell(Name)="data">
            <v-clamp autoresize :max-lines="1">{{ data.value }}</v-clamp>
          </template>
          <template v-slot:cell(actions)="data">
            <router-link :to="`/license/${data.item.SfId}`" style="margin-left: 10px;"><b-icon-download /> Download</router-link>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import VClamp from 'vue-clamp';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

export default {
  name: 'Licenses',
  components: {
    VClamp,
  },
  data() {
    return {
      test: 'test',
      items: [],
      fields: [
        {
          key: 'ArvcId',
          label: 'Membership',
          sortable: true,
        },
        {
          key: 'Account',
          label: 'Business',
          sortable: true,
        },
        {
          key: 'Type',
          label: 'Type',
          sortable: true,
        },
        {
          key: 'Expires',
          label: 'Expiration',
          sortable: true,
        },
        { key: 'actions', label: '' },
      ],
    };
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        const rawItems = await axios.get(`${server}/api/memberships`);
        if (rawItems.data.redirect) {
          window.location.href = rawItems.data.redirect;
          return;
        }
        this.items = rawItems.data.filter((x) => x.Class.includes('License'));
      } catch (err) {
        console.log({ listListingsError: err });
      }
    });
  },
};
</script>
